import React from 'react';
import styles from './hero-banner.module.css';
import Carousel from "react-bootstrap/Carousel";
import CTAButton from "../../common/v2/CTA-Button/cta-button";

interface HeroBannerProps {
    title: string;
    subtitle1?: string;
    subtitle2?: string;
    subtitle3?: string;
    buttonText?: string;
    showButton?: boolean;
    backgroundImageUrl: string;
    onButtonClick?: () => void;
    textWrapperClass?: string;
}

const HeroBanner: React.FC<HeroBannerProps> = ({
                                                   title, subtitle1, subtitle2,
                                                   backgroundImageUrl,
                                                   subtitle3,
                                                   showButton

                                               }) => {

    return (
        <Carousel className={styles.carousel} indicators={false} controls={false}>
            <Carousel.Item className={`${styles.carousel_item}`}>
                <div className={styles.contentWrapper}>
                    <div className={`${styles.textWrapper}`}>
                        <h3 className={styles.carousel_item_title}>
                            <span style={{color:"#865FAE"}}>{title}</span>
                            <span style={{color:"#327CCD"}}>{subtitle1}</span>
                            <span style={{color:"#5A3B76"}}>{subtitle2}</span>
                        </h3>
                        <h2 className={styles.carousel_item_title_sub}>
                            {subtitle3}
                        </h2>

                        {/*<CTAButton text={"Nous Joindre"}/>*/}
                        {showButton && (
                            <CTAButton text={"Nous Joindre"} />
                        )}
                    </div>
                    <div className={styles.imageWrapper}>
                    <img
                            src={backgroundImageUrl}
                            alt="Banner"
                            className={styles.bannerImg}
                            loading="eager"
                        />
                    </div>
                </div>
            </Carousel.Item>
        </Carousel>
    );
};

export default HeroBanner;
